import React from 'react';
import { useLocation } from 'react-router';
import { SEO_VERTICAL_PAGES } from '../../constants/seoConfig';
import SEO from './SEO';
import SeoPageIntro from './SeoPageIntro';

/** Injects SEO and optional visible H1/intro for vertical browse routes. */
export default function VerticalPageSeo({ showIntro = true }) {
  const { pathname } = useLocation();
  const meta = SEO_VERTICAL_PAGES.find((p) => p.path === pathname);
  if (!meta) return null;
  return (
    <>
      <SEO
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
        url={meta.path}
      />
      {showIntro ? (
        <SeoPageIntro
          h1={meta.h1}
          description={meta.introDescription !== undefined ? meta.introDescription : meta.description}
          oneLine={pathname === '/designers'}
        />
      ) : null}
    </>
  );
}
